module.exports = __webpack_public_path__ + "health1.3U0ucr4T.svg";